import { render, staticRenderFns } from "./LinkingCompetenceToRa.vue?vue&type=template&id=acb529b4&scoped=true"
import script from "./LinkingCompetenceToRa.vue?vue&type=script&lang=js"
export * from "./LinkingCompetenceToRa.vue?vue&type=script&lang=js"
import style0 from "./LinkingCompetenceToRa.vue?vue&type=style&index=0&id=acb529b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb529b4",
  null
  
)

export default component.exports